
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delete-pages",
      function () {
        return require("private-next-pages/delete-pages.js");
      }
    ]);
  